import { Box, Flex, Heading, Text, Grid } from '@chakra-ui/react';
import HubspotContactForm from '../../components/HubspotContactForm/HubspotContactForm';

interface FormSectionProps {
    region: string;
    formId: string;
    portalId: string;
    sectionTitle: string;
    sectionSubtitle: string;
}

function FormSection({
    formId,
    portalId,
    region,
    sectionTitle,
    sectionSubtitle,
}: FormSectionProps) {
    return (
        <Grid
            templateColumns={{ base: '1fr', lg: 'repeat(2, 1fr)' }}
            gap={'50px'}
            position={'relative'}
            marginTop={{ base: '30px', md: '50px' }}
        >
            <Flex flexDir={'column'} justifyContent={'center'}>
                <Heading
                    as="h2"
                    fontSize={{ base: '30px', lg: '34px' }}
                    lineHeight={{ base: '37px', lg: '48px' }}
                    fontWeight={'600'}
                    mb={'20px'}
                >
                    {sectionTitle}
                </Heading>
                <Text fontSize={{ base: '16px', lg: '18px' }}>{sectionSubtitle}</Text>
            </Flex>
            <Box
                position={'relative'}
                _before={{
                    base: {
                        content: '""',
                        position: 'absolute',
                        height: 'calc(100% + 20rem)',
                        top: '-10rem',
                        width: '100vw',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        zIndex: -2,
                        backgroundColor: 'rgba(238, 238, 238, 1)',
                    },
                    md: {
                        height: 'calc(100% + 10rem)',
                        width: '100%',
                        left: '0',
                        transform: 'translateX(0)',
                    },
                    lg: {
                        top: '-5rem',
                    },
                    xl: {
                        height: 'calc(100% + 12rem)',
                        top: '-6rem',
                    },
                }}
            >
                <HubspotContactForm region={region} portalId={portalId} formId={formId} />
            </Box>
        </Grid>
    );
}

export default FormSection;
